import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetManualDto } from '../../../common/spdCore/autogenerated/spdApiClient';

import { ManualAttachmentsPreview } from './ManualAttachmentsPreview';

interface ManualSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
}

export const manualForGrid = (manual: GetManualDto) => {
  const tests = (manual.manualTests || [])
    .map(manualTest => manualTest.test?.name)
    .filter(Boolean)
    .join(', ');

  return {
    key: manual.id,
    values: {
      'manual.name': manual.name,
      'manual.description': manual.description,
      'manual.tests': tests,
      'manual.attachments': (
        <ManualAttachmentsPreview attachments={manual.attachments} />
      ),
    },
  };
};

export const ManualSearch: React.FC<ManualSearchProps> = props => {
  const columns = [
    { header: 'Nazwa', property: 'manual.name' },
    { header: 'Opis', property: 'manual.description' },
    { header: 'Wybrane testy', property: 'manual.tests', noSorting: true },
    {
      header: '',
      property: 'manual.attachments',
      noSorting: true,
      noFilter: true,
    },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="manual.name"
      availablePageSizes={[10, 20, 50]}
      onRowClick={props.onRowClick}
      emptyGridMessage="Brak podręczników w systemie"
      refresh={props.refresh}
      showExport={true}
    />
  );
};
